module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MR - Mauritania.9c91e63c.svg";